@use "variables" as *;

.title {
  font-size: $fontSize-l;
  margin: $spacing-s $spacing-m $spacing-s $spacing-s;
}

.mainContent {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.appBar {
  height: $appBarHeight;
}

.toolbar {
  padding-left: $spacing-s;
  padding-right: $spacing-s;
}

.mainBody {
  display: flex;
  min-height: calc(100% - #{$appBarHeight});
  padding: 0 !important;
}

.detailBody {
  width: 100%;
  padding: $spacing-m $spacing-m $spacing-l $spacing-m;
}

.collectionTitle {
  font-size: $fontSize-ml;
  font-weight: bold;
  text-transform: none !important;
  padding-left: $spacing-s;
  padding-right: $spacing-s;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.lastUpdated {
  font-size: $fontSize-xs;
  margin-left: $spacing-s;
}

.lastUpdatedDate {
  font-weight: bold;
}

.expandIcon {
  font-size: $fontSize-l !important;
}
